// Mock data for Artemis Red LLC landing page

export const stats = [
  {
    id: 1,
    value: "500+",
    label: "Government Projects Delivered"
  },
  {
    id: 2,
    value: "98%",
    label: "Client Satisfaction Rate"
  },
  {
    id: 3,
    value: "15+",
    label: "Years of Experience"
  },
  {
    id: 4,
    value: "$2B+",
    label: "Contract Value Managed"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Deep Government Expertise",
    description: "Our team brings decades of combined experience in federal, state, and local government operations and compliance requirements.",
    icon: "shield-check"
  },
  {
    id: 2,
    title: "Proven Track Record",
    description: "Successfully delivered hundreds of mission-critical projects across multiple government agencies and departments.",
    icon: "award"
  },
  {
    id: 3,
    title: "Cutting-Edge Technology",
    description: "We leverage the latest technologies and best practices to deliver secure, scalable, and compliant solutions.",
    icon: "cpu"
  },
  {
    id: 4,
    title: "Compliance-First Approach",
    description: "Every solution we deliver meets or exceeds government standards including FedRAMP, FISMA, and NIST requirements.",
    icon: "file-check"
  }
];

export const governmentSectors = [
  {
    id: 1,
    name: "Federal Government",
    description: "Specialized solutions for federal agencies including defense, intelligence, and civilian departments.",
    icon: "landmark"
  },
  {
    id: 2,
    name: "State Government",
    description: "Custom technology implementations for state-level agencies, departments, and legislative bodies.",
    icon: "building-2"
  },
  {
    id: 3,
    name: "Local Government",
    description: "Municipal and county solutions for public services, infrastructure, and community programs.",
    icon: "home"
  }
];

export const services = [
  {
    id: 1,
    title: "Technology Consulting",
    description: "Strategic technology planning and implementation guidance for government agencies seeking to modernize their operations.",
    icon: "lightbulb"
  },
  {
    id: 2,
    title: "Custom Software Development",
    description: "Secure, compliant software solutions tailored to meet specific government requirements and workflows.",
    icon: "code"
  },
  {
    id: 3,
    title: "Cybersecurity Solutions",
    description: "Comprehensive security assessments, implementation, and monitoring to protect sensitive government data.",
    icon: "lock"
  },
  {
    id: 4,
    title: "Cloud Migration & Management",
    description: "FedRAMP-compliant cloud solutions that enable secure, scalable government operations.",
    icon: "cloud"
  },
  {
    id: 5,
    title: "Data Analytics & AI",
    description: "Advanced analytics and artificial intelligence solutions to drive data-informed government decision-making.",
    icon: "bar-chart"
  },
  {
    id: 6,
    title: "Compliance & Risk Management",
    description: "Ensure your technology infrastructure meets all federal and state compliance requirements.",
    icon: "shield"
  }
];

export const handleContactSubmit = (formData) => {
  // Mock function for contact form submission
  console.log("Contact form submitted:", formData);
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        success: true,
        message: "Thank you for your inquiry. We'll contact you within 24 hours."
      });
    }, 1000);
  });
};
